/* eslint-disable */
import services from 'services';
import mixpanel from '@/vendors/mixpanel/mixpanel';
import * as types from './mutation-types';
import UserProfile from "@/entities/UserProfile";

export default {
  loginWithUserToken: async ({ commit }, userToken) => {
    commit(types.LOGIN, { user: {}, userToken: userToken });
  },
  loginUser: async ({ commit, rootGetters }, user) => {
    const alreadyLoggedInBefore = rootGetters['auth/currentUserId'];
    const shop = rootGetters['$hbui/shopAuth/currentShop'];

    if (!alreadyLoggedInBefore) {
      mixpanel.identify(user.uid);
      mixpanel.people.set({
        $email: user.email,
        $name: user.displayName,
        uid: user.uid,
      });
      if (shop && shop.shopEmail && shop.shopId) {
        mixpanel.people.set({
          emailMagasin: shop.shopEmail,
          idMagasin: shop.shopId,
        });
      }
    }
    commit(types.LOGIN, { user });
  },
  loginWithCustomToken: async ({ commit, dispatch }, userToken) => {
    const user = await services.authService.loginWithCustomToken(userToken);
    dispatch('loginUser', user);
  },
  loginWithCredentials: async ({ commit, dispatch, rootGetters }, { email, password }) => {
    const user = await services.authService.loginWithCredentials(email, password);
    dispatch('loginUser', user);
  },
  logout: ({ commit, dispatch }) => {
    return services.authService.logout().then(() => {
      commit(types.LOGOUT);
    });
  },
  updateUser: async ({ commit }) => {
    const user = services.authService.currentUser();
    commit(types.UPDATE_USER, user);
  },
  fetchCurrentUserProfile: async ({ commit, getters, rootGetters }, userId) => {
    console.log('FETCH CURRENT USER PROFILE', userId);
    let currentUserId = userId;
    if (!currentUserId) {
      currentUserId = getters['currentUserId'];
    }
    const customClaims = await services.authService.getCurrentCustomTokenUserInfo(currentUserId);
    if (customClaims) {
      const profile = new UserProfile(customClaims);
      profile.shopId = rootGetters["$hbui/shopAuth/currentShopId"];
      profile.status = 'active';
      console.log('THE USER PROFILE', profile);
      commit('SET_USER_PROFILE', profile);
      return profile;
    }
    const profile = await services.userService.getUser(currentUserId);
    commit('SET_USER_PROFILE', profile);
    return profile;
  },
};
